import settings from '../../config/settings';
import axiosNonAuth from './axiosNonAuth';

const {apiBaseUrl} = settings;

export default class ProductsApi {
    static getProductDataSource(id) {
      return axiosNonAuth.get(`${apiBaseUrl}/product-sources/${id}/`);
  }
}
